import '../../resources/css/dashboard/HoodMap.scss';
import React, { Component } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PropTypes from 'prop-types';
import IconOnline from '../../resources/img/ico_hood_online.svg';
import IconOffline from '../../resources/img/ico_hood_offline.svg';
// import Geocode from "react-geocode";    // geocode test

class HoodMap extends Component {
    state = {
        activeMarker: null,        
        showingInfoWindow: false,
        selectedPlace: {},
        activeDeviceStatus: {}
    }

    mapStyle = {
        width: '100%',
        height: '100%'
    }

    onMarkerClick = (props, marker, e) => {
        this.props.clickMap(marker.mac);
    }

    displayMarkers = (devices) => {
        if (devices) {
            return devices
            // .filter(device => {
            //     const location = device.location;
            //     return location && location.lat && location.lng;            
            // })    // check location is all has data
            .map((device, index) => {
                let position = {}, icon = {};
                // const location = device.location;
                position = {
                    lat: device.latitude,
                    lng: device.longitude
                };
                const isOnline = device.isOnline;
                if (isOnline === 1) {
                    icon = {
                        url: IconOnline,
                        size: {
                            height: 72,
                            width: 72
                        }
                    };
                } else {
                    icon = {
                        url: IconOffline,
                        size: {
                            height: 72,
                            width: 72
                        }
                    };
                }
                return (
                    <Marker key={device.thingName} id={device.thingName} 
                    position={position}
                    mac={device.thingName}
                    name={device.name}
                    icon={icon}
                    onClick={this.onMarkerClick} />
                )
            });
        }
    }

    // componentDidMount() {
    //     /* -------------------- Geocode test start --------------------*/
    //     // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
    //     Geocode.setApiKey(window.CONFIG.GOOGLE.apiKey);

    //     // set response language. Defaults to english.
    //     Geocode.setLanguage("en");

    //     // set response region. Its optional.
    //     // A Geocoding request with region=es (Spain) will return the Spanish city.
    //     Geocode.setRegion("es");

    //     // Enable or disable logs. Its optional.
    //     Geocode.enableDebug();

    //     // Get address from latidude & longitude.
    //     Geocode.fromLatLng("37.735687", "-122.239980").then(
    //         response => {
    //             if (response.results) {
    //                 const address = response.results[0].formatted_address;
    //                 console.info("results", response.results);
    //                 console.info("address", address);
    //             }
            
    //         },
    //         error => {
    //             console.error(error);
    //         }
    //     );
    //     /* -------------------- Geocode test end --------------------*/
    // }

    render() {
        const { devices } = this.props;
        let lng = -122.239980;
        let lat = 37.735687;
        if (devices && devices.length > 0) {
            const device = devices[0];
            lng = device.longitude;
            lat = device.latitude;
        }

        return (
            <Map
                className='hood-map'
                google={this.props.google}
                style={this.mapStyle}
                initialCenter={{
                    lng: lng,
                    lat: lat
                }}
                // zoom={17}
                zoom={12}
                streetViewControl={false}
                mapTypeControl={false}
            >
                {this.displayMarkers(devices)}
            </Map>
        )
    }
}

HoodMap.propTypes = {
    idToken: PropTypes.string.isRequired,
    devices: PropTypes.array,
}

export default GoogleApiWrapper({
    apiKey: (window.CONFIG.GOOGLE.apiKey)
})(HoodMap)